import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";

function NavBar() {
  return (
    <Navbar
      expand="lg"
      bg="dark"
      variant="dark"
      sticky="top"
      className="shadow-lg"
    >
      <Container>
        {/* Brand / Logo */}
        <Navbar.Brand
            as={NavLink}
            to="/"
            className="fw-bold fs-4 d-flex align-items-center gap-2"
            >
            {/* Glowing lightning icon */}
            <i className="bi bi-lightning-charge-fill text-warning fs-3 glow-icon"></i>

            {/* Name + subtitle stacked */}
            <div className="d-flex flex-column lh-sm">
                <span className="fw-bold text-white fs-5">Donovan Monteiro</span>
                <small className="text-warning">Software Engineer • Fullstack Developer</small>
            </div>
            </Navbar.Brand>



        {/* Toggle for mobile */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        <Navbar.Collapse id="navbar-nav">
          {/* Links */}
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/" end>
              <i className="bi bi-house-door-fill me-1"></i> Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/projects">
              <i className="bi bi-kanban-fill me-1"></i> Projects
            </Nav.Link>
            <Nav.Link as={NavLink} to="/blogs">
              <i className="bi bi-book-half me-1"></i> Blogs
            </Nav.Link>
            

            <NavDropdown
              title={
                <>
                  <i className="bi bi-stars me-1"></i> More
                </>
              }
              id="nav-dropdown"
              menuVariant="dark"
            >
              <NavDropdown.Item as={NavLink} to="/contact">
                <i className="bi bi-envelope-fill me-2"></i> Contact
              </NavDropdown.Item>
              <NavDropdown.Item href="https://github.com/don0716" target="_blank">
                <i className="bi bi-github me-2"></i> GitHub
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="https://www.linkedin.com/in/donovan-monteiro-5131b1148/" target="_blank">
                <i className="bi bi-linkedin me-2"></i> LinkedIn
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
